import QRCode from "react-qr-code";
import { HandHeart } from "lucide-react";
import { AuthImage } from "./AuthImage";
import { useI18n } from "../i18n";
import { usePlans, publicFileUrl } from "../lib/plans";
import { useSettings } from "../lib/providers";

const TIERS = {
  silver: { bg: "linear-gradient(135deg,#1c2230 0%,#2c3446 50%,#141924 100%)", accent: "#D7DCE4", ring: "#C0C7D2" },
  gold: { bg: "linear-gradient(135deg,#0E1220 0%,#1B2236 55%,#0A0D14 100%)", accent: "#D4AF37", ring: "#D4AF37" },
  gold_plus: { bg: "linear-gradient(135deg,#1a1206 0%,#3a2a0c 45%,#0d0a05 100%)", accent: "#F2D27A", ring: "#F2D27A" },
};

export const IdCard = ({ member }) => {
  const { t } = useI18n();
  const { planName } = usePlans();
  const { settings } = useSettings();
  const b = settings?.branding || {};
  const tier = TIERS[member.package] || TIERS.gold;
  const issued = member.approved_at ? new Date(member.approved_at).toLocaleDateString() : "";
  return (
    <div className="print-card relative overflow-hidden rounded-[18px] text-white shadow-2xl"
      style={{ width: 430, height: 270, background: tier.bg, border: `1.5px solid ${tier.ring}` }} data-testid="id-card">
      <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full opacity-20" style={{ background: tier.accent, filter: "blur(40px)" }} />
      <div className="flex items-center justify-between px-5 pt-4">
        <div className="flex items-center gap-2">
          {b.logo_path ? <img src={publicFileUrl(b.logo_path)} alt="" className="h-7 w-7 rounded object-contain" /> : <HandHeart className="h-6 w-6" style={{ color: tier.accent }} />}
          <div>
            <p className="font-serif text-lg font-bold leading-none" style={{ color: tier.accent }}>{b.site_name || "Helping Hands"}</p>
            <p className="text-[9px] uppercase tracking-[0.25em] text-white/60">{t("id_title")}</p>
          </div>
        </div>
        <span className="rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-widest" style={{ background: tier.accent, color: "#0A0D14" }} data-testid="id-card-tier">
          {planName(member.package)}
        </span>
      </div>
      <div className="flex gap-4 px-5 pt-4">
        <AuthImage path={member.photo_path} className="h-[120px] w-[96px] rounded-lg border" testId="id-card-photo" />
        <div className="flex-1 space-y-2 text-[11px]">
          <div><p className="uppercase tracking-widest text-white/50 text-[8px]">{t("id_name")}</p><p className="font-serif text-lg font-semibold leading-tight" data-testid="id-card-name">{member.full_name}</p></div>
          <div><p className="uppercase tracking-widest text-white/50 text-[8px]">{t("dash_member_id")}</p><p className="font-mono text-sm" style={{ color: tier.accent }} data-testid="id-card-member-id">{member.member_id}</p></div>
          <div className="flex gap-4">
            <div><p className="uppercase tracking-widest text-white/50 text-[8px]">{t("adm_phone")}</p><p className="font-mono">{member.phone}</p></div>
            <div><p className="uppercase tracking-widest text-white/50 text-[8px]">{t("id_issued")}</p><p className="font-mono">{issued}</p></div>
          </div>
        </div>
        <div className="self-end rounded-md bg-white p-1.5"><QRCode value={`HH:${member.member_id}`} size={70} /></div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1.5" style={{ background: `linear-gradient(90deg, transparent, ${tier.accent}, transparent)` }} />
    </div>
  );
};
